<template>
  <b-row>
    <b-col cols="12" md="2" v-text="dayLabel" />
    <b-col cols="12" md="6">
      <b-form-select :options="options" v-model="setting.setting" :disabled="disabled" />
    </b-col>
    <b-col cols="12" md="4">
      <date-picker v-model="setting.start_date" :config="datepickerOptions" :required="hasDate" :disabled="!hasDate || disabled" />
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment';
import DatePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import User from '../../classes/user';

export default {
  components: { DatePicker },

  props: {
    value: {
      type: Object,
      default: {},
    },
    editable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      datepickerOptions: {
        locale: 'nl-NL',
        format: 'DD/MM/YYYY',
        calendarWeeks: true,
        useCurrent: false,
        minDate: moment(),
      },
      setting: this.value,
      options: [
        { value: null, text: 'Uitgeschakeld', hasDate: false },
        { value: 'A', text: 'Wekelijks', hasDate: false },
        { value: 'E', text: 'Even weken', hasDate: false },
        { value: 'O', text: 'Oneven weken', hasDate: false },
        { value: '3', text: 'Drie wekelijks', hasDate: true },
        { value: '4', text: 'Vier wekelijks', hasDate: true },
        { value: 'M1', text: 'Maandelijks - 1ste week van de maand', hasDate: false },
        { value: 'M2', text: 'Maandelijks - 2de week van de maand', hasDate: false },
        { value: 'M3', text: 'Maandelijks - 3de week van de maand', hasDate: false },
        { value: 'M4', text: 'Maandelijks - 4de week van de maand', hasDate: false },
        { value: 'ML', text: 'Maandelijks - laatste week', hasDate: false },
      ],
    }
  },
  computed: {
    dayLabel() {
      const days = {
        monday: "Maandag",
        tuesday: "Dinsdag",
        wednesday: "Woensdag",
        thursday: "Donderdag",
        friday: "Vrijdag",
        saturday: "Zaterdag",
        sunday: "Sunday"
      };

      return days[this.setting.day];
    },

    hasDate() {
      return this.options.find(x => x.value === this.setting.setting).hasDate;
    },
    disabled() {
      return !this.editable || User.cant('transportschema aanpassen');
    }
  },
  watch: {
    setting: {
      handler: function(value) {
        if ((!this.options.find(x => x.value === value.setting).hasDate) && value.start_date !== null) {
          this.$set(this.setting, 'start_date', null);
        }

        this.$emit('input', value);
      },
      deep: true,
    },
  }
};

</script>
